import { render, staticRenderFns } from "./CrudWorkDetails.vue?vue&type=template&id=afb9f534&scoped=true&"
import script from "./CrudWorkDetails.vue?vue&type=script&lang=ts&"
export * from "./CrudWorkDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CrudWorkDetails.vue?vue&type=style&index=0&id=afb9f534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb9f534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VCol,VForm,VIcon,VRow,VTextField,VTextarea})
